import React from "react";
import { DividendData } from "../../../data/reports/dividends/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { DisplayBoolNumber } from "../../components/common/DisplayBoolNumber";
import { Status } from "../../../data/models";

export interface DisplayDividendsMainAttributesProps {
  dividends: DividendData;
}

export const DisplayDividendsMainAttributes: React.FunctionComponent<DisplayDividendsMainAttributesProps> = ({
  dividends,
}) => {
  const style = useDisplaySingleEmementStyles();
  const {
    getString,
    getDateString,
    getFormatedNumberString,
  } = React.useContext(LocalizationContext);


  return (
    <div className={style.root}>

      <div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divSettlement")}</span>
				<span className={style.value}>{getDateString(dividends.settlDate, "DD.MM.YYYY")}</span>
			</div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("divCalculateDate")}</span>
 				<span className={style.value}>{getDateString(dividends.calculateDate, "DD.MM.YYYY")}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("divSecurityIsin")}</span>
        <span className={style.value}>{dividends.securityIsin}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("divSecurityName")}</span>
        <span className={style.value}>{dividends.securityName}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("divAccount")}</span>
        <span className={style.value}>{dividends.clientAccount}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("divCliBank")}</span>
        <span className={style.value}>{dividends.clientBank}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("divCliBankCity")}</span>
        <span className={style.value}>{dividends.bankCity}</span>
      </div>

			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divQty")}</span>
				<span className={style.value}> {getFormatedNumberString(dividends.qty)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divGrossAmtPerShare")}</span>
				<span className={style.value}> {getFormatedNumberString(dividends.grossAmtPerShare, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divGrossAmount")}</span>
				<span className={style.value}> {getFormatedNumberString(dividends.grossAmt, true)}</span>
			</div>
      <div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divTaxPercent")}</span>
				<span className={style.value}> {`${getFormatedNumberString(dividends.taxPercent, true)} %`}</span>
      </div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divTax")}</span>
				<span className={style.value}> {getFormatedNumberString(dividends.tax, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divNet")}</span>
				<span className={style.value}> {getFormatedNumberString(dividends.netAmt, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divBrokersCommission")}</span>
				<span className={style.value}> {getFormatedNumberString(dividends.brokersCommission, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("divPayAmt")}</span>
				<span className={style.value}> {getFormatedNumberString(dividends.payAmt, true)}</span>
			</div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("divValuta")}</span>
        <span className={style.value}>{dividends.currencyCode}</span>
      </div>

    </div>
  );
};


